import styled, { ITheme } from '../../../../../theme'
import { IWithSize } from '../../../../BookingCalendar/Calendar/Calendar'

const UserName = styled.div<IWithSize>`
  font-family: 'Open Sans', sans-serif;
  font-size: ${({ size }) => (size ? 16 * size : 16)}px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: ${({ size }) => (size ? 230 * size : 230)}px;
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo};
`

const UserNameHeader = styled(UserName)<IWithSize>`
  font-family: Montserrat;
  font-size: ${({ size }) => (size ? 14 * size : 14)}px;
  line-height: ${({ size }) => (size ? 1.15 * size : 1.15)};
  letter-spacing: 0;
  font-weight: 300;
  color: ${(props: ITheme) => props.theme.colors.palette.white};
`

export default UserName
export { UserName, UserNameHeader }
